import { render, staticRenderFns } from "./seafirapse.vue?vue&type=template&id=67a84d80&scoped=true&"
import script from "./seafirapse.vue?vue&type=script&lang=js&"
export * from "./seafirapse.vue?vue&type=script&lang=js&"
import style0 from "./seafirapse.vue?vue&type=style&index=0&id=67a84d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a84d80",
  null
  
)

export default component.exports